import * as React from 'react';

import Help20 from './Help20';

export const help20 = () => <Help20 />;

export default {
    title: 'Icon|Fill|Help20',
    component: Help20,
    parameters: {
        notes: "`import Help20 from 'box-ui-elements/es/icon/fill/Help20';`",
    },
};
